import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import dateFormat from 'dateformat';
import classnames from 'classnames';

import { VisitorEntities } from 'client/data/models/visitor';
import { LOAN_PAYMENT } from 'site-modules/shared/constants/allowed-inventory-request-params';
import { getPriceStringV2 } from 'site-modules/shared/utils/price-utils';
import { getTransparentPricing } from 'site-modules/shared/components/profile/price-drop-alerts/alerts-utils';
import { CardCompareSelect } from 'site-modules/shared/components/profile/card-compare-select/card-compare-select';
import { cardRemoveDialog } from 'site-modules/profile/components/shared/card-remove-dialog/card-remove-dialog';
import { UsurpInventoryCard } from 'site-modules/shared/components/inventory/usurp-inventory-card/usurp-inventory-card';

import './regular-card.scss';

export function RegularCardUI({
  vinData,
  submittedTs = null,
  isSubmittedLead = false,
  compareSelect = null,
  visitorLocation = null,
  isMobile = false,
}) {
  const { priceDrop, hasNewAlert } = vinData;

  const {
    vehicleInfo: {
      styleInfo: { year, make, model, trim },
    },
  } = vinData;
  const ariaLabel = `Compare ${year} ${make} ${model} ${trim}`;
  const showPriceDrop = !!(priceDrop && getTransparentPricing(vinData).transparentPrice);

  return (
    <Fragment>
      <UsurpInventoryCard
        vehicle={vinData}
        visitorLocation={visitorLocation}
        isMobile={isMobile}
        grayIcons
        isDealerSrp
        paymentType={LOAN_PAYMENT} // to skip paymenttype in vdp link
        radius={0} // to skip radius in vdp link
        showCtaButton
        showInventoryHeart={false}
        showInventoryBadge={false}
      />
      {compareSelect && (
        <CardCompareSelect
          vinData={vinData}
          compareSelect={compareSelect}
          isSubmittedLead={isSubmittedLead}
          ariaLabel={ariaLabel}
        />
      )}
      <div
        className={classnames(
          'pos-a left-0 top-0 w-100 pt-0_25 px-0_5 d-flex justify-content-between align-items-start overlay-top',
          {
            'overlay-contrast': isSubmittedLead,
          }
        )}
      >
        {showPriceDrop && (
          <span
            className={classnames('rounded p-0_25 me-0_25 bg-white size-12 text-nowrap', {
              'text-primary-darker': hasNewAlert,
              'text-gray-darker': !hasNewAlert,
            })}
          >
            <span className="icon-arrow-down8 size-10 me-0_25" aria-hidden />
            Price drop {getPriceStringV2(Math.floor(priceDrop))}
          </span>
        )}
        {isSubmittedLead && (
          <span className="text-white medium text-shadow-contrast">
            Dealer contacted {dateFormat(submittedTs, 'mm/dd/yy')}
          </span>
        )}
      </div>
    </Fragment>
  );
}

RegularCardUI.propTypes = {
  vinData: PropTypes.shape({}).isRequired, // InventoryVin + profile-utils.js#setInventoryData
  submittedTs: PropTypes.string,
  isSubmittedLead: PropTypes.bool,
  compareSelect: PropTypes.shape({}),
  visitorLocation: VisitorEntities.Location,
  isMobile: PropTypes.bool,
};

const RegularCardWrapper = cardRemoveDialog(RegularCardUI);

export function RegularCard(props) {
  const { isSubmittedLead, vinData } = props;

  const {
    vehicleInfo: {
      styleInfo: { year, make, model, trim },
    },
  } = vinData;
  const ariaLabel = `${year} ${make} ${model} ${trim}`;

  return (
    <RegularCardWrapper
      {...props}
      dialogClassName="regular-card h-100 d-flex flex-column justify-content-between pos-r"
      canRemove={!isSubmittedLead}
      ariaLabel={ariaLabel}
    />
  );
}
